/**
 * Feature Comparison Table - Accordion functionality
 *
 * Handles expanding/collapsing feature descriptions when info icons are clicked.
 */

document.addEventListener("DOMContentLoaded", () => {
	// Find all info toggle buttons
	const toggleButtons = document.querySelectorAll(".cb-feature-info-toggle");

	toggleButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			e.preventDefault();

			const featureId = button.getAttribute("data-feature-id");
			const descriptionDiv = document.getElementById(`${featureId}-description`);

			if (!descriptionDiv) {
				return;
			}

			const isExpanded = button.getAttribute("aria-expanded") === "true";

			// Close all other expanded descriptions first (accordion behavior)
			document.querySelectorAll(".cb-feature-info-toggle").forEach((otherButton) => {
				if (otherButton !== button) {
					otherButton.setAttribute("aria-expanded", "false");
					const otherId = otherButton.getAttribute("data-feature-id");
					const otherDescription = document.getElementById(`${otherId}-description`);
					if (otherDescription) {
						otherDescription.classList.add("cb-hidden");
					}
				}
			});

			// Toggle current description
			if (isExpanded) {
				button.setAttribute("aria-expanded", "false");
				descriptionDiv.classList.add("cb-hidden");
			} else {
				button.setAttribute("aria-expanded", "true");
				descriptionDiv.classList.remove("cb-hidden");
			}
		});
	});
});
